import { TableColumn } from '../../../components/_EOS/GenericTable'
import { ProductExternalReference } from '../../../interfaces/Producto/ProductExternalReference'
import { YesNoBadge } from '../../../components/YesNoBadge'
import React from 'react'

export const getColumnsConfig = (): TableColumn<ProductExternalReference>[] => [
  { key: 'name', title: 'Nombre' },
  { key: 'description', title: 'Descripción' },
  {
    key: 'isActive',
    title: 'Activo',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]
